import { useId, useLayoutEffect, useSyncExternalStore } from 'react'

const owners = new Map<string, string>()
const listeners = new Set<() => void>()
const emit = () => listeners.forEach((listener) => listener())
const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function useOverlayActivity(open: boolean, owner?: string) {
  const id = useId()
  useLayoutEffect(() => {
    if (!open) return
    owners.set(id, owner ?? id)
    emit()
    return () => {
      owners.delete(id)
      emit()
    }
  }, [id, open, owner])
}

export function useOverlayBlocked(exceptOwner: string) {
  return useSyncExternalStore(
    subscribe,
    () => [...owners.values()].some((owner) => owner !== exceptOwner),
    () => false,
  )
}
